import React, { useEffect, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { validation, validationText } from "../../utils/constants.js";
import ThemeInput from "../ThemeComponent/ThemeInput";
import ThemeSelect from "../ThemeComponent/ThemeSelect";
import { VscEye, VscEyeClosed } from "react-icons/vsc";
import ThemeTextArea from "../ThemeComponent/ThemeTextArea";
import { errorToast, success } from "../../utils/helpers.js";
import {
  useAddClientMutation,
  useUpdateClientMutation,
} from "../../Redux/services/adminApi.js";
import ThemeSpinner from "../ThemeComponent/ThemeSpinner";

const AddClient = ({ setIsOpen, modalData, refetch }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showpassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };
  const [addClient, { isLoading: addLoading }] = useAddClientMutation();
  const [updateClient, { isLoading }] = useUpdateClientMutation();

  const options = [
    { label: "Doctor", value: "1" },
    { label: "Helper", value: "2" },
    { label: "Nurse", value: "3" },
  ];

  const onSubmit = async (data) => {
    const payload = { ...data, id: modalData?.id };
    try {
      let response;
      if (modalData) {
        response = await updateClient(payload);
      } else {
        response = await addClient(data);
      }

      if (response.data.code === 200) {
        setIsOpen(false);
        refetch();
        success(
          response?.data?.message || modalData
            ? "Client Updated SUccessfully"
            : "Client Added Successfully"
        );
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        errorToast(error?.response?.data?.message, "error");
      }
    }
  };

  useEffect(() => {
    if (modalData) {
      setValue("name", modalData.name);
      setValue("email", modalData.email);
      setValue("mobile_no", modalData.mobile_no);
      setValue("username", modalData.username);
      setValue("password", modalData.password_view);
      setValue("notes", modalData.notes);
    } else {
      reset();
    }
  }, []);

  return (
    <div className="edit-profile-content">
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="form-edit-profile mt-2"
      >
        <ThemeInput
          name="name"
          errors={errors}
          control={control}
          type={"text"}
          className={""}
          placeholder={"Client Name"}
          rules={{
            required: {
              value: true,
              message: validationText.nameRequired,
            },
            maxLength: {
              value: validation.nameMax,
              message: validationText.nameMax,
            },
          }}
        />
        <ThemeInput
          name="hospital_name"
          errors={errors}
          control={control}
          type={"text"}
          className={"mt-3"}
          placeholder={"Hospital Name"}
          rules={{
            required: {
              value: true,
              message: validationText.nameRequired,
            },
            maxLength: {
              value: validation.nameMax,
              message: validationText.nameMax,
            },
          }}
        />
        <ThemeInput
          name="email"
          errors={errors}
          control={control}
          type={"email"}
          className={"mt-3"}
          placeholder={"Email Address"}
          rules={{
            required: {
              value: true,
              message: validationText.emailRequired,
            },
            maxLength: {
              value: validation.emailMax,
              message: validationText.emailMax,
            },
          }}
        />
        <ThemeInput
          name="mobile_no"
          errors={errors}
          control={control}
          type={"number"}
          className={"mt-3"}
          placeholder={"Phone Number"}
          rules={{
            required: {
              value: true,
              message: validationText.phoneNumber,
            },
            maxLength: {
              value: validation.passwordMax,
              message: validationText.phoneNumberMax,
            },
          }}
        />

        <div className="password-input">
          <ThemeInput
            name="password"
            errors={errors}
            control={control}
            type={!showpassword ? "password" : "text"}
            className={"mt-3"}
            placeholder={"Password"}
            rules={{
              required: {
                value: true,
                message: validationText.passwordRequired,
              },
              maxLength: {
                value: validation.passwordMax,
                message: validationText.passwordMax,
              },
              minLength: {
                value: validation.passwordMin,
                message: validationText.passwordMin,
              },
            }}
          />
          <span
            className="icon cursor"
            onClick={() => setShowPassword(!showpassword)}
          >
            {showpassword ? (
              <VscEyeClosed size={20} className="text-black" />
            ) : (
              <VscEye size={20} className="text-black" />
            )}
          </span>
        </div>

        <ThemeInput
          name="address"
          errors={errors}
          control={control}
          type={"text"}
          className={"mt-3"}
          placeholder={"Address"}
          rules={{
            required: {
              value: true,
              message: "Address is required",
            },
            maxLength: {
              value: validation.nameMax,
              message: validationText.nameMax,
            },
          }}
        />

        <ThemeTextArea
          name="notes"
          control={control}
          errors={errors}
          type="text"
          placeholder={"Notes"}
          rules={{
            required: {
              value: true,
              message: "Notes is required",
            },
            maxLength: {
              value: 500,
              message: "Maximun 500 characters is allow",
            },
          }}
        />
        <span className="text-grey">0 / 500 Characters</span>

        <div className="d-flex gap-3 mt-4">
          <div className="btn-submit w-50">
            <Button
              className="cancel-btn w-100 bg-grey"
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </Button>
          </div>
          <div className="btn-submit w-50">
            <Button
              disabled={isLoading}
              type="submit"
              className="theme-btn w-100"
            >
              {isLoading || addLoading ? (
                <ThemeSpinner />
              ) : modalData ? (
                "Update Client"
              ) : (
                "Add Client"
              )}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AddClient;
